// extracted by mini-css-extract-plugin
export default {"root":"PopoverContent_root__DbZRd"};